import type { InvestigationType } from "@validereinc/domain";

/**
 * Collapses duplicate investigation rows that can appear when infinite-query
 * pages overlap after refetches or list resorting. Keeps the newest `updated_at`
 * copy per id. History panel only — does not affect InvestigationsListPage.
 */
export const deduplicateInvestigationHistoryEntries = (
  investigations: InvestigationType[]
): InvestigationType[] => {
  const investigationsById = new Map<string, InvestigationType>();

  for (const investigation of investigations) {
    const existingInvestigation = investigationsById.get(investigation.id);

    if (
      !existingInvestigation ||
      new Date(investigation.updated_at).getTime() >
        new Date(existingInvestigation.updated_at).getTime()
    ) {
      investigationsById.set(investigation.id, investigation);
    }
  }

  return Array.from(investigationsById.values());
};
